import React, { useEffect, useState } from 'react';
const trackFbEvent = (event: string, data?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', event, data);
  }
};
type Plan = 'megapack' | 'megapack-pro';
export function Pricing() {
  useEffect(() => {
    const section = document.getElementById('pricing');
    if (!section) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        trackFbEvent('ViewContent', {
          content_name: 'Pricing Section',
          content_category: 'Megapack Anti Pantalla'
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.3
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const [selected, setSelected] = useState<Plan>('megapack-pro');
  const cartUrls: Record<Plan, string> = {
    megapack: 'https://checkout.construyeprogreso.com/cart/48209465475242:1',
    'megapack-pro': 'https://checkout.construyeprogreso.com/cart/48209465704618:1'
  };
  const ctaLabels: Record<Plan, string> = {
    megapack: 'SÍ, QUIERO EL MEGAPACK ANTI PANTALLA',
    'megapack-pro': 'SÍ, QUIERO EL MEGAPACK + MÉTODO DESCONECTADO™'
  };
  return <section id="pricing" className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(248, 250, 252)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-198">
      <div className="mx-auto max-w-3xl" data-id="element-199">
        {/* TÍTULO */}
        <h2 className="font-black text-center text-gray-900 m-0 mb-2 text-[25px]" data-id="element-200">
          Elegí tu{' '}
          <span className="text-orange-500" data-id="element-201">Megapack Anti Pantalla:</span>
        </h2>
        <p className="text-center text-gray-500 m-0 mb-8 text-[12px]" data-id="element-202">
          Las dos opciones incluyen los 6 bonos exclusivos completos
        </p>

        <div className="mb-6 mx-auto max-w-2xl" data-id="element-203">
          {/* OPCIÓN 1 — MEGAPACK BASE */}
          <button onClick={() => setSelected('megapack')} className={`w-full text-left transition-all rounded-xl p-4 cursor-pointer shadow-sm ${selected === 'megapack' ? 'border-2 border-orange-500' : 'border border-gray-200'}`} style={{
          backgroundColor: 'rgb(255, 255, 255)'
        }} data-id="element-204">
            <div className="flex flex-row items-center gap-3" data-id="element-205">
              <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-206">
                <div className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${selected === 'megapack' ? 'border-orange-500' : 'border-gray-300'}`} data-id="element-207">
                  {selected === 'megapack' && <div className="h-2.5 w-2.5 bg-orange-500 rounded-full" data-id="element-208" />}
                </div>
                <div className="min-w-0 flex-1" data-id="element-209">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-210">
                    <span className="text-sm sm:text-base" data-id="element-211">🧒</span>
                    <span className="text-sm sm:text-base font-black text-gray-900" data-id="element-212">
                      MEGAPACK ANTI PANTALLA
                    </span>
                  </div>
                  <p className="text-xs text-gray-500 mt-1 mb-0" data-id="element-213">
                    6 tomos + 6 bonos · +500 páginas · 2 a 7 años completo
                  </p>
                </div>
              </div>
              <div className="shrink-0 text-right" data-id="element-214">
                <div className="text-xs text-gray-500 line-through" data-id="element-215">
                  $49.990
                </div>
                <div className="text-xl sm:text-2xl font-black text-gray-900" data-id="element-216">
                  $19.990
                </div>
              </div>
            </div>
          </button>

          {/* OPCIÓN 2 — MEGAPACK + MÉTODO DESCONECTADO™ */}
          <button onClick={() => setSelected('megapack-pro')} className={`w-full text-left transition-all rounded-xl p-4 mt-3 cursor-pointer shadow-sm ${selected === 'megapack-pro' ? 'border-2 border-orange-500' : 'border border-gray-200'}`} style={{
          backgroundColor: 'rgb(255, 247, 237)',
          boxShadow: selected === 'megapack-pro' ? 'rgba(249, 115, 22, 0.15) 0px 0px 30px 0px' : 'none'
        }} data-id="element-217">
            <div className="flex gap-3 flex-row items-center justify-end" data-id="element-218">
              <div className="flex items-start gap-3 flex-1 min-w-0" data-id="element-219">
                <div className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 mt-0.5 ${selected === 'megapack-pro' ? 'border-orange-500' : 'border-gray-300'}`} data-id="element-220">
                  {selected === 'megapack-pro' && <div className="h-2.5 w-2.5 bg-orange-500 rounded-full" data-id="element-221" />}
                </div>
                <div className="min-w-0 flex-1" data-id="element-222">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-223">
                    <span className="text-sm sm:text-base" data-id="element-224">🏆</span>
                    <span className="text-sm sm:text-base font-black text-gray-900" data-id="element-225">
                      MEGAPACK ANTI PANTALLA + MÉTODO DESCONECTADO™
                    </span>
                  </div>
                  <div className="mt-1.5 flex flex-wrap items-center gap-1.5" data-id="element-226">
                    <span className="bg-orange-500 text-[10px] font-black text-white rounded-full px-2 py-0.5" data-id="element-227">
                      ⭐ MÁS ELEGIDO
                    </span>
                    <span className="bg-orange-100 text-[10px] font-bold text-orange-500 border border-orange-300 rounded-full px-2 py-0.5" data-id="element-228">
                      AHORRÁS $30.000
                    </span>
                  </div>
                  <p className="text-xs text-gray-600 mt-1.5 mb-0" data-id="element-229">
                    Todo el Megapack + guía para eliminar la dependencia a la
                    pantalla en 7 días, rutinas anti-berrinche y plan semanal
                    listo para aplicar hoy.
                  </p>
                </div>
              </div>
              <div className="shrink-0 text-right" data-id="element-230">
                <div className="text-xs text-gray-500 line-through" data-id="element-231">
                  $79.990
                </div>
                <div className="text-xl sm:text-2xl font-black text-orange-500" data-id="element-232">
                  $27.990
                </div>
              </div>
            </div>
          </button>
        </div>

        {/* CTA PRINCIPAL */}
        <div className="mx-auto max-w-2xl" data-id="element-233">
          <a href={cartUrls[selected]} onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: selected === 'megapack-pro' ? 'Megapack Anti Pantalla + Método Desconectado™' : 'Megapack Anti Pantalla',
          content_category: 'Anti Pantalla',
          value: selected === 'megapack-pro' ? 27990 : 19990,
          currency: 'ARS'
        })} className="block w-full text-white text-center text-sm sm:text-lg font-black rounded-2xl py-5 no-underline will-change-transform shadow-xl transition-transform active:scale-95" style={{
          background: 'linear-gradient(135deg, rgb(234, 88, 12) 0%, rgb(249, 115, 22) 50%, rgb(251, 146, 60) 100%)',
          boxShadow: '0 8px 32px rgba(249, 115, 22, 0.5), 0 2px 8px rgba(0,0,0,0.15)',
          letterSpacing: '0.5px'
        }} data-id="element-234">
            🛒 {ctaLabels[selected]} →
          </a>

          <p className="text-center text-xs italic text-gray-500 mt-3 mb-0" data-id="element-235">
            La más elegida por mamás que quieren recuperar las tardes sin
            pantallas ni berrinches
          </p>

          {/* GARANTÍAS */}
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3 text-xs text-gray-600 rounded-lg px-4 py-3 shadow-sm" style={{
          backgroundColor: 'rgb(255, 255, 255)',
          border: '1px solid rgba(249, 115, 22, 0.2)'
        }} data-id="element-236">
            <span data-id="element-237">🔒 Pago seguro</span>
            <span data-id="element-238">⚡ Acceso en 5 min</span>
            <span data-id="element-239">🛡️ Garantía 7 días</span>
            <span data-id="element-240">💳 Mercado Pago</span>
            <span data-id="element-241">📄 PDF listo para imprimir</span>
          </div>
        </div>
      </div>
    </section>;
}